import { RefreshDataStatus } from './refresh-etas.model';
import { Moment } from 'moment';
import * as moment from 'moment'

export class TripRefreshDistance {

  public status: RefreshDataStatus;

  public latestKnowPingId: string;

  public latestKnowPingCreatedAt: Moment;

  public metricDistance: number;

  public imperialDistance: number;

  static fromDto(d): TripRefreshDistance {
    const tripRefreshDistance = new TripRefreshDistance();

    tripRefreshDistance.status                   = d.status;
    tripRefreshDistance.latestKnowPingId         = d.latest_known_ping_id;
    tripRefreshDistance.latestKnowPingCreatedAt  = d.latest_known_ping_created_at ? moment(d.latest_known_ping_created_at) : null;
    tripRefreshDistance.metricDistance           = d.metric_distance;
    tripRefreshDistance.imperialDistance         = d.imperial_distance;

    return tripRefreshDistance;
  }

}
